(function () {
    var GITHUB_USER = 'iMrSquare';
    var API_URL = 'https://api.github.com/users/' + GITHUB_USER + '/repos?sort=updated&per_page=100';
    var BADGE_HOSTS = ['shields.io', 'badge.fury.io', 'img.shields.io', 'codecov.io', 'travis-ci', 'github.com/actions', 'circleci.com'];

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
    }

    function formatUpdated(isoDate) {
        var date = new Date(isoDate);
        return date.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
    }

    function looksLikeBadge(url) {
        return BADGE_HOSTS.some(function (host) { return url.indexOf(host) !== -1; });
    }

    function resolveReadmeImageUrl(repo, src) {
        if (/^https?:\/\//i.test(src)) return src;
        var clean = src.replace(/^\.?\//, '');
        return 'https://raw.githubusercontent.com/' + repo.full_name + '/' + repo.default_branch + '/' + clean;
    }

    function findFirstLogo(repo, readmeText) {
        var matches = [];
        var mdRe = /!\[[^\]]*\]\(([^)\s]+)/g;
        var htmlRe = /<img[^>]+src=["']([^"']+)["']/g;
        var m;
        while ((m = mdRe.exec(readmeText))) matches.push({ index: m.index, src: m[1] });
        while ((m = htmlRe.exec(readmeText))) matches.push({ index: m.index, src: m[1] });
        matches.sort(function (a, b) { return a.index - b.index; });

        for (var i = 0; i < matches.length; i++) {
            var url = resolveReadmeImageUrl(repo, matches[i].src);
            if (!looksLikeBadge(url)) return url;
        }
        return null;
    }

    function fetchLogo(repo) {
        var url = 'https://raw.githubusercontent.com/' + repo.full_name + '/' + repo.default_branch + '/README.md';
        return fetch(url)
            .then(function (res) { return res.ok ? res.text() : null; })
            .then(function (text) { return text ? findFirstLogo(repo, text) : null; })
            .catch(function () { return null; });
    }

    function cmdRow(label, value) {
        return (
            '<div class="imr-proj-cmd">' +
                '<span class="imr-proj-cmd-prompt"><span class="sym">$</span> ' + label + '</span>' +
                '<span class="imr-proj-cmd-val">' + value + '</span>' +
            '</div>'
        );
    }

    function renderCard(repo) {
        var description = escapeHtml(repo.description || 'Sin descripción todavía.');
        var updated = formatUpdated(repo.pushed_at || repo.updated_at);

        var card = document.createElement('a');
        card.className = 'imr-term imr-proj-card';
        card.href = repo.html_url;
        card.target = '_blank';
        card.rel = 'noopener noreferrer';
        card.innerHTML =
            '<div class="imr-term-bar">' +
                '<span class="imr-term-dot r"></span><span class="imr-term-dot y"></span><span class="imr-term-dot g"></span>' +
                '<span class="imr-term-title">' + escapeHtml(repo.full_name) + '</span>' +
            '</div>' +
            '<div class="imr-proj-logo" data-logo-slot></div>' +
            '<div class="imr-proj-body imr-proj-cmds">' +
                cmdRow('nombre', escapeHtml(repo.name)) +
                cmdRow('descripcion', description) +
                cmdRow('actualizado', updated) +
            '</div>';

        fetchLogo(repo).then(function (logoUrl) {
            var slot = card.querySelector('[data-logo-slot]');
            if (logoUrl) {
                var img = document.createElement('img');
                img.src = logoUrl;
                img.alt = '';
                img.loading = 'lazy';
                img.onerror = function () { slot.classList.add('imr-proj-logo--fallback'); slot.innerHTML = ''; };
                slot.appendChild(img);
            } else {
                slot.classList.add('imr-proj-logo--fallback');
                slot.textContent = repo.name.charAt(0).toUpperCase();
            }
        });

        return card;
    }

    function renderEmpty(container, message) {
        container.innerHTML = '<div class="imr-proj-empty">' + message + '</div>';
    }

    function renderRepos(container, repos, limit) {
        var filtered = repos.filter(function (repo) {
            return !repo.fork && repo.name.toLowerCase() !== GITHUB_USER.toLowerCase();
        });

        if (!filtered.length) {
            renderEmpty(container, 'Todavía no hay proyectos públicos en GitHub. <a href="https://github.com/' + GITHUB_USER + '" target="_blank" rel="noopener noreferrer">Ver perfil →</a>');
            return;
        }

        var toShow = limit ? filtered.slice(0, limit) : filtered;
        container.innerHTML = '';
        toShow.forEach(function (repo) {
            container.appendChild(renderCard(repo));
        });
    }

    function init() {
        var containers = document.querySelectorAll('[data-github-projects]');
        if (!containers.length) return;

        fetch(API_URL, { headers: { Accept: 'application/vnd.github+json' } })
            .then(function (res) {
                if (!res.ok) throw new Error('GitHub API ' + res.status);
                return res.json();
            })
            .then(function (repos) {
                containers.forEach(function (container) {
                    var limit = container.dataset.githubProjects ? parseInt(container.dataset.githubProjects, 10) : null;
                    renderRepos(container, repos, limit);
                });
            })
            .catch(function () {
                containers.forEach(function (container) {
                    renderEmpty(container, 'No se pudieron cargar los proyectos ahora mismo. <a href="https://github.com/' + GITHUB_USER + '" target="_blank" rel="noopener noreferrer">Verlos en GitHub →</a>');
                });
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
